import {
  IconBolt,
  IconDeviceDesktop,
  IconChartBar,
  IconChartHistogram,
  IconChartPie,
  IconTable,
  IconSettingsAutomation,
  IconReport
} from '@tabler/icons';
import { getDeviceName, formatDeviceCodeLabel } from 'utils/deviceLabel';

const icons = {
  IconBolt,
  IconDeviceDesktop,
  IconChartBar,
  IconChartHistogram,
  IconChartPie,
  IconTable,
  IconSettingsAutomation,
  IconReport
};

const getStatusIndicatorForDevice = (device, deviceStatusByCode = {}) => {
  const code = Number(device?.DeviceCode);
  const status = deviceStatusByCode[code];
  const connectionStatus = status?.connectionStatus;
  const lastUpdate = status?.lastUpdate;

  if (connectionStatus === 'ONLINE') {
    return {
      color: '#2e7d32',
      tooltip: 'Online'
    };
  }

  if (connectionStatus === 'NEVER_CONNECTED') {
    return {
      color: '#9e9e9e',
      tooltip: 'Never connected'
    };
  }

  if (connectionStatus === 'OFFLINE') {
    return {
      color: '#d32f2f',
      tooltip: `Última conexión ${lastUpdate ?? 'unknown'}`
    };
  }

  return null;
};

const Pages = (devices, expandedDevice, handleExpand, deviceStatusByCode = {}) => {
  if (!devices) {
    return [];
  }

  const menuItems = {
    id: 'pages',
    title: 'Datapoints',
    type: 'group',
    children: devices.map((device) => ({
      id: `datapoint-${device.DeviceCode}`,
      title: getDeviceName(device) || `Datapoint ${device.DeviceCode}`,
      caption: formatDeviceCodeLabel(device.DeviceCode),
      statusIndicator: getStatusIndicatorForDevice(device, deviceStatusByCode),
      type: 'collapse',
      icon: icons.IconBolt,
      children:
        expandedDevice === device.DeviceCode
          ? [
              /*
              {
                id: `monitor-${device.DeviceCode}`,
                title: 'Monitor',
                type: 'item',
                icon: icons.IconDeviceDesktop,
                url: `/monitor/${device.DeviceCode}`,
                target: true
              },
              */
              {
                id: `electr-param-${device.DeviceCode}`,
                title: <>Parámetros Eléctricos</>,
                type: 'item',
                icon: icons.IconChartBar,
                url: `/pages/electr-param/${device.DeviceCode}`,
                breadcrumbs: false
              },
              {
                id: `realtime-${device.DeviceCode}`,
                title: 'Tiempo Real',
                type: 'item',
                icon: icons.IconChartHistogram,
                url: `/pages/realtime/${device.DeviceCode}`,
                breadcrumbs: false
              },
              {
                id: `analisishistorico-${device.DeviceCode}`,
                title: 'Análisis Histórico',
                type: 'item',
                icon: icons.IconChartPie,
                url: `/pages/analisishistorico/${device.DeviceCode}`,
                breadcrumbs: false
              },
              {
                id: `eventos-${device.DeviceCode}`,
                title: 'Eventos',
                type: 'item',
                icon: icons.IconTable,
                url: `/pages/events/${device.DeviceCode}`,
                breadcrumbs: false
              },
              {
                id: `customEvents-${device.DeviceCode}`,
                title: 'Configuración de eventos',
                type: 'item',
                icon: icons.IconSettingsAutomation,
                url: `/pages/custom-events/${device.DeviceCode}`,
                breadcrumbs: false
              },
              {
                id: `configuracion-reportes-${device.DeviceCode}`,
                title: 'Reportes',
                type: 'item',
                icon: icons.IconReport,
                url: `/pages/configuracion-reportes/${device.DeviceCode}`,
                breadcrumbs: false
              },
              {
                id: `configurar-datapoint-${device.DeviceCode}`,
                title: 'Configurar Datapoint',
                type: 'item',
                icon: icons.IconSettingsAutomation,
                url: `/datapoint/modificarDatapoint/${device.DeviceCode}`,
                breadcrumbs: false
              }
            ]
          : [],
      onClick: () => handleExpand(device.DeviceCode)
    }))
  };

  return menuItems;
};

export default Pages;
